// -*- coding: utf-8 -*-
/**
 * API fetcher for Stage 069 Task Dispatcher Cockpit.
 * Governance Anchor: TASK-MARKET_HUB-069-TASK-HARMONIZER-AND-WORKER-COCKPIT
 */

import { apiClient } from '../../api/client';
import { WorkerTelemetrySnapshot } from './types';

export async function fetchWorkerTelemetrySnapshot(): Promise<WorkerTelemetrySnapshot> {
  return apiClient.get<WorkerTelemetrySnapshot>('/api/v1/meta/workers/telemetry');
}
